import { connect } from 'react-redux';
import { Helper, IHelperProps } from '../../components/Helper';
import { IApplicationState } from '../../types/redux';

type THelperStateProps = Pick<IHelperProps, 'page'>;

function mapStateToProps(state: IApplicationState): THelperStateProps {
  return {
    page: state.helper && state.helper.page || 'main',
  };
}

export const HelperContainer = connect(mapStateToProps)(Helper);
